import { createSelector } from 'reselect'
import { dataConstants } from 'services/redux/data/constants'
import _ from 'lodash'

const selectTimeslotGroup = createSelector(
	[
		(state) => {
			return state.data[dataConstants.TIMESLOT_GROUPS];
		},
		(state, guid) => {
			return guid;
		}
	],
	( groups, guid ) => {
		return _.find( groups, ( o ) => {
			return o.guid === guid;
		} )
	}
)

export default selectTimeslotGroup;